import { computed, onMounted, reactive, toRefs } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import qs from '@halobear/utils/qs'

import * as Api from '@/api/travel'
import { xml as getXml } from '@/api/pano'

export default () => {
  const state = reactive({
    pano_id: '',
    name: '',
    pano_list: [],
    data: {},
  })

  const route = useRoute()
  const router = useRouter()

  // 获取场地详情
  const fetchDetail = async () => {
    const { hall_id, pano_id } = route.query
    const res = await Api.hallDetail2(hall_id)
    const { pano_list = [], name = '' } = res
    state.name = name
    state.pano_list = pano_list
    state.pano_id = (pano_id && Number(pano_id)) || (pano_list[0] || {}).pano_id
    state.data = res
    share()
  }

  // 选择服务
  const selectService = (pano_id) => {
    state.pano_id = pano_id
    share()
  }

  // 返回
  const back = () => {
    const { hall_id = '', hotel_id = '', title = '', phone } = route.query
    const query = { hall_id, hotel_id, title, id: hall_id }
    phone && (query.phone = phone)
    router.replace({ name: 'travel', query })
  }

  // 当前显示选景
  const panoDetail = computed(() => {
    const { pano_id, pano_list } = state
    return (pano_id && pano_list.find((item) => item.pano_id === pano_id)) || pano_list[0] || {}
  })

  // 全景xml
  const xml = computed(() => {
    const query = route.query.hotel_id ? route.query : qs.parse(window.location.href.split('#')[0])
    let { hotel_id = 0, hall_id = 0, phone = '' } = query
    const loading = phone ? 'halobear-loading' : 'licheng-loading'
    return state.pano_id ? getXml({ hotel_id, hall_id, pano_id: state.pano_id, loading }) : ''
  })

  // 标题
  const title = computed(() => {
    return `${state.name} | ${panoDetail.value.name}`
  })

  // 过滤当前方案的列表
  const list = computed(() => {
    return state.pano_list.filter((item) => item.pano_id !== state.pano_id)
  })

  // 所有方案的列表
  const alllist = computed(() => {
    return state.pano_list
  })
  const nowPanoId = computed(() => {
    return state.pano_id
  })

  const share = () => {
    const { cover, hall_id = '', hotel_id = '', pano_id } = panoDetail.value
    if (!hall_id) return
    const url = `${location.origin}${location.pathname}?hall_id=${hall_id}&hotel_id=${hotel_id}&pano_id=${pano_id}&title=${document.title}`
    const path = `/pages/webview/index?url=${encodeURIComponent(url)}&title=${document.title}`
    hall_id &&
      window.wx &&
      wx.miniProgram.postMessage({
        data: { title: title.value || document.title, path, imageUrl: cover },
      })
    // const hall_id = route.query.hall_id || qs.get('hall_id')
    // const hotel_id = route.query.hotel_id || qs.get('hotel_id')
    // const target = state.list.find((item) => item.hall_id == hall_id) || {}
    // const title = target.name ? `${state.data.name} ${target.name}` : state.data.name
    // const { cover } = targetHall.value
    // cover &&
    //   window.wx &&
    //   wx.miniProgram.postMessage({
    //     data: { title, path, imageUrl: cover },
    //   })
  }

  onMounted(fetchDetail)

  return {
    ...toRefs(state),
    xml,
    title,
    selectService,
    back,
    panoDetail,
    list,
    alllist,
    nowPanoId,
  }
}
